// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const UnoCopilotSidecarContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-copilotsidecarcontainer" */ "./UnoCopilotSidecarContainer")).then((page)=>{
        return {
            default: page.UnoCopilotSidecarContainer
        };
    });
export const LazyUnoCopilotSidecarContainer = /*#__PURE__*/ lazy(UnoCopilotSidecarContainerLazyLoader);
